import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/ManualPage.css";
import { HourglassSplit, QuestionCircle } from "react-bootstrap-icons";

const Header = () => {
  const navigate = useNavigate();
  const { logout, remainingTime } = useAuth();

  const handleBack = () => {
    navigate("/");
  };
  return (
    <header className="manual_header-container">
      <div className="manual_header-inner">
        <div className="manual_header-title">주문 시스템 메뉴얼</div>

        <button className="manual-btn" onClick={handleBack}>
          돌아가기
        </button>
      </div>
    </header>
  );
};

export default Header;
